<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>{{title}}</h1>
      <v-row>
           <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-for="(item, key) in listOfData" :key="key">
            <!-- <v-text-field
              :label="`Level ${key + 1}`"
              v-model="model[`level${item}`]"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(key + 1)">mdi-magnify</v-icon>
              </template>
            </v-text-field> -->
            <department-lookup 
              :class-padding="classPadding"
              :title="'Departments'"
              :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Department' &&   showInput(tab, key)"
              :disable-lookup="tab != key">
            </department-lookup>

            <division-lookup 
              :class-padding="classPadding"
              :title="'Division'"
              :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Division' && showInput(tab, key)"
              :disable-lookup="tab != key">
            </division-lookup>

            <section-lookup 
              :class-padding="classPadding"
              :title="'Section'"
              :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Section' && showInput(tab, key)"
              :disable-lookup="tab != key">
            </section-lookup>

            <group-lookup 
              :class-padding="classPadding"
              :title="'Group'"
                :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Group' && showInput(tab, key)"
              :disable-lookup="tab != key">
            </group-lookup>

            <project-lookup 
              :class-padding="classPadding"
              :title="'Project File'"
              :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Project Code' && showInput(tab, key)"
              :disable-lookup="tab != key">
            </project-lookup>

            <pay-loc-lookup 
              :class-padding="classPadding"
              :title="'Payroll Location'"
                :label="`${item}`"
              v-model="model[`level${key + 1}`]"
              :code-value="false"
              v-if="item == 'Payroll Location' && showInput(tab, key)"
              :disable-lookup="tab != key">
            </pay-loc-lookup>

          </v-col>
           <!-- <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[0,1,2,3,4,5].includes(tab)">
            <v-text-field
              :label="listOfData[0]"
              v-model="model.level1"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(1)" v-if="tab == 0">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[1,2,3,4,5].includes(tab)">
            <v-text-field
              :label="listOfData[1]"
              v-model="model.level2"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(2)" v-if="tab == 1">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[2,3,4,5].includes(tab)">
            <v-text-field
              :label="listOfData[2]"
              v-model="model.level3"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(3)" v-if="tab == 2">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[3,4,5].includes(tab)">
            <v-text-field
              :label="listOfData[3]"
              v-model="model.level4"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(4)" v-if="tab == 3">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[4,5].includes(tab)">
            <v-text-field
              :label="listOfData[4]"
              v-model="model.level5"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(5)" v-if="tab == 4">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-if="[5].includes(tab)">
            <v-text-field
              :label="listOfData[5]"
              v-model="model.level6"
              :class="classPadding"
              autocomplete="off"
              readonly
              
            >
              <template slot="append">
                <v-icon @click.stop="search(6)" v-if="tab == 5">mdi-magnify</v-icon>
              </template>
            </v-text-field>
          </v-col> -->
      </v-row>
      <v-tabs
        v-model="tab"
        background-color="primary"
        dark
      >
        <v-tab
          v-for="(item, key) in listOfData"
          :key="key"
        >
          Level {{ key + 1 }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item
          v-for="(item, key) in listOfData"
          :key="`item-${key}`"
        >
          <v-card flat>
            <v-card-text v-if="key != 5">

                <department-lookup 
                  :class-padding="classPadding"
                  :title="'Departments'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Department'"
                  :readonly="false">
                </department-lookup>

                <division-lookup 
                  :class-padding="classPadding"
                  :title="'Division'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Division'">
                </division-lookup>

                <section-lookup 
                  :class-padding="classPadding"
                  :title="'Section'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Section'">
                </section-lookup>

                 <group-lookup 
                  :class-padding="classPadding"
                  :title="'Group'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Group'">
                </group-lookup>

                <project-lookup 
                  :class-padding="classPadding"
                  :title="'Project File'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Project Code'">
                </project-lookup>

                <pay-loc-lookup 
                  :class-padding="classPadding"
                  :title="'Payroll Location'"
                  :label="`For Level ${key + 2}`"
                  v-model="inner[`level${key+ 2}`]"
                  :code-value="false"
                  v-if="listOfData[key + 1] == 'Payroll Location'">
                </pay-loc-lookup>
            </v-card-text>
          </v-card>
          <v-data-table v-if="key == 0 && level2Items.length > 0" :items="level2Items" :headers="level2Headers" >
            <template v-slot:item.actions="{ item }">
               <v-btn
                  @click.stop="delete2(item)"
                  text
                  icon
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
          </v-data-table>
          <v-data-table v-if="key == 1 && level3Items.length > 0" :items="level3Items" :headers="level3Headers" >
            <template v-slot:item.actions="{ item }">
               <v-btn
                  @click.stop="delete3(item)"
                  text
                  icon
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
          </v-data-table>
          <v-data-table v-if="key == 2 && level4Items.length > 0" :items="level4Items" :headers="level4Headers" >
            <template v-slot:item.actions="{ item }">
               <v-btn
                  @click.stop="delete4(item)"
                  text
                  icon
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
          </v-data-table>
          <v-data-table v-if="key == 3 && level5Items.length > 0" :items="level5Items" :headers="level5Headers" >
            <template v-slot:item.actions="{ item }">
               <v-btn
                  @click.stop="delete5(item)"
                  text
                  icon
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
          </v-data-table>
          <v-data-table v-if="key == 4 && level6Items.length > 0" :items="level6Items" :headers="level6Headers" >
            <template v-slot:item.actions="{ item }">
               <v-btn
                  @click.stop="delete6(item)"
                  text
                  icon
                >
                  <v-icon color="error">mdi-delete</v-icon>
                </v-btn>
            </template>
          </v-data-table>
        </v-tab-item>

      </v-tabs-items>

      <v-row>
        <v-col cols="12" >
          <v-btn outlined text color="success" @click.stop="add" :loading="loading">Add</v-btn>&nbsp;
          <!-- <v-btn outlined text @click.stop="cancel" >Cancel</v-btn> -->
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
const DivisionLookup = () => import("../../../setup/employment-info/organizational-level/division/Lookup")
const DepartmentLookup = () => import("../../../setup/employment-info/organizational-level/department/Lookup")
const SectionLookup = () => import("../../../setup/employment-info/organizational-level/section/Lookup")
const GroupLookup = () => import("../../../setup/employment-info/organizational-level/group/Lookup")
const ProjectLookup = () => import("../../../setup/employment-other-info/others/project-file/project-list/Lookup")
const PayLocLookup = () => import("../../../setup/general/payroll-location/Lookup")
import isEmpty from "lodash/isEmpty"
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT_H = "/api/hierarchy"
const API_ENDPOINT = "/api/pmeLevel"
export default {
  metaInfo: {
    title: "PME Level Setup",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  mixins:[userAccessMixin],
  data: ()=> ({
    classPadding: "my-0 py-0",
    title: "PME Level Setup",
    model: {
      level1: {},
      level2: {},
      level3: {},
      level4: {},
      level5: {},
      level6: {}
    },
    inner: {
      level1: {},
      level2: {},
      level3: {},
      level4: {},
      level5: {},
      level6: {}
    },
    tab: null,
    items: [
      { tab: 'Level 1', content: 'Tab 1 Content' },
      { tab: 'Level 2', content: 'Tab 2 Content' },
      { tab: 'Level 3', content: 'Tab 3 Content' },
      { tab: 'Level 4', content: 'Tab 4 Content' },
      { tab: 'Level 5', content: 'Tab 5 Content' },
      { tab: 'Level 6', content: 'Tab 6 Content' },
    ],
    hierarchy: {},
    loading: false,
    selectedDep: {},
    selectedDiv: {},
    selectedSec: {},
    selectedGroup: {},
    selectedProj: {},
    selectedPayLoc: {},
    level1: {},
    level2: {},
    level3: {},
    level4: {},
    level5: {},
    level6: {},
    level1Items: [],
    level2Items: [],
    level3Items: [],
    level4Items: [],
    level5Items: [],
    level6Items: [],
    level2Headers: [
      { 
        text: "Code",
        value: "level2Code",
        sortable: false
      },
       { 
        text: "Description",
        value: "level2Desc",
        sortable: false
      },
       { 
        text: "",
        value: "actions",
        sortable: false
      }
    ],
    level3Headers: [
      { 
        text: "Code",
        value: "level3Code",
        sortable: false
      },
       { 
        text: "Description",
        value: "level3Desc",
        sortable: false
      },
       { 
        text: "",
        value: "actions",
        sortable: false
      }
    ],
    level4Headers: [
      { 
        text: "Code",
        value: "level4Code",
        sortable: false
      },
       { 
        text: "Description",
        value: "level4Desc",
        sortable: false
      },
       { 
        text: "",
        value: "actions",
        sortable: false
      }
    ],
    level5Headers: [
      { 
        text: "Code",
        value: "level5Code",
        sortable: false
      },
       { 
        text: "Description",
        value: "level5Desc",
        sortable: false
      },
       { 
        text: "",
        value: "actions",
        sortable: false
      }
    ],
    level6Headers: [
      { 
        text: "Code",
        value: "level6Code",
        sortable: false
      },
       { 
        text: "Description",
        value: "level6Desc",
        sortable: false
      },
       { 
        text: "",
        value: "actions",
        sortable: false
      }
    ]
  }),
  components: {
    DivisionLookup,
    DepartmentLookup,
    SectionLookup,
    GroupLookup,
    ProjectLookup,
    PayLocLookup
  },
  computed: {
    listOfData() {
      var array = []
      var i;
      for (i = 1; i <= 6; i++) {
        var value = this.hierarchy[`level${i}`];
        if(value !== null)
          array.push(value);
      }

      return array;
    },
    countOfData() {
      return this.listOfData.length;
    }
  },
  methods: {
     getSetup() {
      this.$axios.get(`${API_ENDPOINT_H}`)
        .then(({ data }) => {
          if(!isEmpty(data)){
             this.hierarchy = data;
          }
        })
        .catch(({ response }) => {
           this.$toast.error(response.data.message);
        })
    },
    search(level){
      
    },
    showInput(tab, key) {
      //console.log(`${tab} ${key}`)
      if(key == 0) {
        return [0,1,2,3,4,5].includes(tab);
      }else if(key == 1){
        return [1,2,3,4,5].includes(tab);
      }else if(key == 2){
        return [2,3,4,5].includes(tab);
      }else if(key == 3){
        return [3,4,5].includes(tab);
      }else if(key == 4){
        return [4,5].includes(tab);
      }else if(key == 5){
        return [5].includes(tab);
      }else {
        return true;
      }
      
    },
    add() {
      this.loading = true;
      var data = {
        Tab: this.tab,
        Outer: this.model,
        Inner: this.inner
      }
      this.$axios.post(`${API_ENDPOINT}`, data)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.refreshItems();
        })  
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false
        })
    },
    cancel() {

    },
    getPmeLevel2(code) {
      this.$axios.get(`${API_ENDPOINT}/2/${code}`)
        .then(({ data }) => {
          this.level2Items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    getPmeLevel3(code) {
      this.$axios.get(`${API_ENDPOINT}/3/${code}`)
        .then(({ data }) => {
          this.level3Items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    getPmeLevel4(code) {
      this.$axios.get(`${API_ENDPOINT}/4/${code}`)
        .then(({ data }) => {
          this.level4Items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    getPmeLevel5(code) {
      this.$axios.get(`${API_ENDPOINT}/5/${code}`)
        .then(({ data }) => {
          this.level5Items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    getPmeLevel6(code) {
      this.$axios.get(`${API_ENDPOINT}/6/${code}`)
        .then(({ data }) => {
          this.level6Items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    refreshItems() {
      if(this.tab == 0){
        this.getPmeLevel2(this.model.level1.code);
      }else if(this.tab == 1) {
        this.getPmeLevel3(this.model.level2.code);
      }else if(this.tab == 2) {
        this.getPmeLevel4(this.model.level3.code);
      }else if(this.tab == 3) {
        this.getPmeLevel5(this.model.level4.code);
      }else if(this.tab == 4) {
        this.getPmeLevel6(this.model.level5.code);
      }
    },
    delete2(item){
      this.$axios.post(`${API_ENDPOINT}/delete`, {
          Code: item.level2Code,
          Level: 2
        })
        .then(({ data }) => {
           this.refreshItems();
           this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    delete3(item){
      this.$axios.post(`${API_ENDPOINT}/delete`, {
        Code: item.level3Code,
        Level: 3
      })
        .then(({ data }) => {
          this.refreshItems();
          this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    delete4(item){
      this.$axios.post(`${API_ENDPOINT}/delete`, {
        Code: item.level4Code,
        Level: 4
      })
        .then(({ data }) => {
           this.refreshItems();
           this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    delete5(item){
      this.$axios.post(`${API_ENDPOINT}/delete`, {
        Code: item.level5Code,
        Level: 5
      })
        .then(({ data }) => {
           this.refreshItems();
           this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    delete6(item){
       this.$axios.post(`${API_ENDPOINT}/delete`, {
        Code: item.level6Code,
        Level: 6
      })
        .then(({ data }) => {
           this.refreshItems();
           this.$toast.success(data.message);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    }
  },
  created() {
    this.getUserAccessRights("PMELevel");
    this.getSetup();
  },
  watch: {
    model: {
      handler(val) {
        if(this.tab == 0){
          this.getPmeLevel2(val.level1.code);
        }else if(this.tab == 1) {
          this.getPmeLevel3(val.level2.code);
        }else if(this.tab == 2) {
          this.getPmeLevel4(val.level3.code);
        }else if(this.tab == 3) {
          this.getPmeLevel5(val.level4.code);
        }else if(this.tab == 4) {
          this.getPmeLevel6(val.level5.code);
        }
      },
      deep: true
    }
  }
}
</script>